<template>
  <div>
    <Modal
    v-model="isShow"
    :width="640"
    :loading="loading"
    :mask-closable="false"
    @on-ok="ok"
    >
      <h3 slot="header" class="modal-header">公式配置</h3>
      <Form
        ref="searchData"
        :model="searchData"
        :rules="ruleValidate"
        :label-width="80">
      <Row>
        <Col span="8">
          <FormItem prop="perTypeCode" label="应用场景">
            <Select v-model="searchData.perTypeCode" placeholder="请选择" >
              <Option value=''>请选择</Option>
              <Option v-for="(item,index) in sceneList" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem prop="projectFid" label="项目名称">
            <Select v-model="searchData.projectFid" placeholder="请选择" >
              <Option value=''>请选择</Option>
              <Option v-for="(item,index) in projectList" :key="'s1'+index" :value="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="18">
          <FormItem prop="formulaKey" label="业绩公式">
            <Select v-model="searchData.formulaKey" placeholder="请选择" filterable>
              <!-- <Option value=''>请选择</Option> -->
              <Option v-for="(item,index) in formulaList" :key="'s3'+index" :value="item.formulaKey">{{item.formulaName}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
      <Col span="18">
        <FormItem prop="createTime" label="">
          <DatePicker style="width:100%" v-model="searchData.createTime" split-panels type="daterange" format="yyyy-MM-dd" placeholder="开始时间-截止时间"></DatePicker>
        </FormItem>
      </Col>
    </Row>
    </Form>
    </Modal>
  </div>
</template>

<script>

import { allFormula , saveFormulaConf} from 'api/formulaconfig'
import { formatDateTime  } from "../../../../../utils/format";

export default {
  name:'Add',
  props:{
    n: {
      type: Number,
      default: 0
    },
    projectList:{
      type:Array,
      default(){
        return []
      }
    },
    sceneList:{
      type:Array,
      default(){
        return []
      }
    },
    roleList:{
      type:Array,
      default(){
        return []
      }
    }
  },
  watch:{
    n(){
      this.$refs['searchData'].resetFields();
      this.isShow = true
    }
  },
  data(){
    const validates = (rule, value, callback) => {
      if (!value[0]) {
        callback(new Error('请选择起止日期'));
      } else{
        callback();
      }
    };
    return{
      loading: true,
      isShow:false,
      formulaList:[],
      searchData: {
        projectFid:'',
        perTypeCode:'',
        formulaKey:'',
        createTime: ['', '']
      },
      ruleValidate:{
        perTypeCode: [
          { required: true, message: '请选择应用场景', trigger: 'change',type:'string' }
        ],
        projectFid: [
          { required: true, message: '请选择项目名称', trigger: 'change',type:'string'}
        ],
        formulaKey:[
          { required: true, message: '请选择业绩公式', trigger: 'change',type:'string'}
        ],
        createTime:[
          { required: true, message: '请选择起止时间', trigger: 'change', type:'array', validator:validates}
        ]
      }
    }
  },
  computed:{
    searchDataParams(){
      function f(data) {
        return data?formatDateTime(data, false):''
      }
      return {
        projectFid:this.searchData.projectFid,
        perTypeCode:this.searchData.perTypeCode,
        formulaKey:this.searchData.formulaKey,
        beginDate: f(this.searchData.createTime[0]),
        endDate:f(this.searchData.createTime[1])
      }
    }
  },
  created(){
    this.getAllFormula();
  },
  methods:{
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
    getAllFormula(){
      allFormula()
      .then( res => {
        this.formulaList = res.data;
      })
    },
    ok(){
      this.$refs['searchData'].validate( bool => {
        if(bool){
          const params = {
            ...this.searchDataParams
          }
          saveFormulaConf(params)
          .then( res => {
            if(res.code == '0'){
              this.$emit('done')
              this.$Message.success('保存成功')
            } else {
              this.$Message.error('保存失败')
            }
          })
          .catch( error => {
            this.$Message.error('保存失败')
          })
          .finally(()=>{
            this.isShow = false
          })
        } else{
          this.changeLoading();
        }
      })

    }
  }
}
</script>

<style>

</style>
